module.exports = __webpack_public_path__ + "img/logo.826294a.png";